module.exports = "/images/checkoutHome.svg";